<template>
  <div class="dep-qrcode">
    <info-block :title="$t('labels.qr_code')"
                marker-color="#A6A6A6"
                hidePaddingTop
                >
      <div class="qrcode">
        <vue-qr
          v-if="stringToEncode"
          :text="stringToEncode"
          :size="256"
          :margin="0"
          colorDark="#aaaaaa"
          colorLight="#ffffff"
          :callback="onCodeGenerate"
        ></vue-qr>
      </div>
    </info-block>
  </div>
</template>

<script>
  import VueQr from 'vue-qr'
  import infoBlock from 'src/components/InfoBlock/InfoBlock.vue'

  export default {
    name: 'qrcode',
    components: {
      VueQr,
      infoBlock
    },
    data () {
      return {
        stringToEncode: null
      };
    },
    mounted () {
      this.stringToEncode = window.location.href;
    },
    methods: {
      onCodeGenerate (dataUrl, id) {
        this.$bus.$emit('qrcode:generated', dataUrl);
      }
    }
  }
</script>

<style lang="scss">
.qrcode {
  img {
    margin: 25px auto 35px auto;
    display: block;
    width: 128px;
    height: auto;
  }
}
</style>